export var CORE = 'core';
export var ANALYTICS = 'analytics';
export var ACCOUNTING = 'accounting';
export var SERVICES = 'ro';
export var DSE_STANDALONE_SERVICES = 'service';
export var PARTS = 'parts';
export var SALES = 'sales';
export var VI = 'vi';
export var DSE = 'dse';
export var GENERAL = 'general';
export var RECENTLY_USED = 'recentlyUsed';
export var DSEV2 = 'dse-v2';
export var CRM = 'crm';
export var INTERNAL = 'internal';
export var DIGITAL_RETAILING = 'digital-retailing';
export var LEADERBOARD = 'leaderboard';
export var PAYROLL = 'payroll';
export var TEMPLATE_BUILDER = 'templates';
export var SUPPORT = 'support';
export var DIGITAL_SIGNAGE_SOLUTIONS = 'digital-signage';
export var FORM = 'form';
var APP_SERVICES = {
  CORE: CORE,
  ANALYTICS: ANALYTICS,
  ACCOUNTING: ACCOUNTING,
  SERVICES: SERVICES,
  DSE_STANDALONE_SERVICES: DSE_STANDALONE_SERVICES,
  PARTS: PARTS,
  SALES: SALES,
  DIGITAL_RETAILING: DIGITAL_RETAILING,
  VI: VI,
  DSE: DSE,
  GENERAL: GENERAL,
  DSEV2: DSEV2,
  CRM: CRM,
  INTERNAL: INTERNAL,
  LEADERBOARD: LEADERBOARD,
  PAYROLL: PAYROLL,
  TEMPLATE_BUILDER: TEMPLATE_BUILDER,
  SUPPORT: SUPPORT,
  DIGITAL_SIGNAGE_SOLUTIONS: DIGITAL_SIGNAGE_SOLUTIONS,
  FORM: FORM
};
export default APP_SERVICES;